import { memo } from 'react';
import { AppText, Button, Modal, Row, Subheader, Theme } from '@streem/ui-react';

interface SendNoteModalProps {
    isOpen: boolean;
    closeModal: () => void;
    sendNote: () => Promise<void>;
}

export const SendNoteModal = memo(function SendNoteModal({
    isOpen,
    closeModal,
    sendNote,
}: SendNoteModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            closeOnEscape={true}
            hideCloseButton
            styleOverride={{
                content: {
                    width: '36.25rem',
                    padding: Theme.spacing.l,
                },
            }}
        >
            <Subheader style={{ marginBottom: '1.5rem' }}>Are You Sure?</Subheader>
            <AppText>
                Once sent, this version of the note will be used by other platforms. Some may
                continue to receive updates.
            </AppText>
            <Row
                justifyContent={'flex-end'}
                width="100%"
                marginTop="2.25rem"
                style={{ gap: '1.125rem' }}
            >
                <Button
                    variant="secondary"
                    onClick={closeModal}
                    data-testid="cancel-send-node-modal-button"
                >
                    Cancel
                </Button>
                <Button onClick={sendNote} data-testid="send-note-modal-button">
                    Send Note
                </Button>
            </Row>
        </Modal>
    );
});
